export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/about-service-4.289953e7-0f95a4.png";